import request from "@/utils/request";

// 公司业绩库-获奖汇总
export function yJWechatAwardSummaryPageList(query) {
    return request({
        url: "/yJAwardSummary/yJWechatAwardSummaryPageList",
        method: "get",
        params: query,
    });
}

// 公司业绩库-查看详情
export function yJWechatAwardSummaryDetail(query) {
    return request({
        url: `/yJAwardSummary/wechatYJAwardSummary`,
        method: "get",
        params: query,
    });
}


//人员执证列表
export function PersonnelCertificateList(query) {
    return request({
        url: "/yJPersonnelCertificate/yJPersonnelCertificatePageList",
        method: "get",
        params: query,
    });
}

//执证类别下拉字典
export function LicenseCategoryDictionary(query) {
    return request({
        url: "/sysDict/listByCode",
        method: "get",
        params: query,
    });
}

//人员执证详情
export function PersonnelCertificateDetail(id) {
    return request({
        url: `yJPersonnelCertificate/yJPersonnelCertificate/${id}`,
        method: "get",
    });
}

//分支机构列表
export function branches(query) {
    return request({
        url: "/yJLocalOffice/yJLocalOfficePageList",
        method: "get",
        params: query,
    });
}

//人分支机构列表详情
export function branchesDetail(id) {
    return request({
        url: `yJLocalOffice/yJLocalOffice/${id}`,
        method: "get",
    });
}


//房建业绩--公司业绩库-汇总业绩
export function HousingConstructionPerformance(query) {
    return request({
        url: "/yJPerformanceSummary/yJPerformanceSummaryPageList",
        method: "get",
        params: query,
    });
}

//汇总业绩表详情
export function HousingConstructionPerformanceDetail(id) {
    return request({
        url: `yJPerformanceSummary/yJPerformanceSummary/${id}`,
        method: "get",
    });
}

